export default "__VITE_ASSET__DVXRW522__"